import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class TransactionsSerializer extends BaseSerializer {
  deserialize(raw) {
    const success = raw?.statusCode == 200 || raw?.id;

    const mockTransactions = [
      {
        id: 'txn_001',
        productName: 'Netflix Premium',
        productImage: '/kingrechargeAssets/netflix.svg',
        amount: 2500,
        status: 'completed',
        createdAt: '2025-01-10T14:30:00Z',
        type: 'subscription',
        duration: '1 mois'
      },
      {
        id: 'txn_002',
        productName: 'Spotify Premium',
        productImage: '/kingrechargeAssets/spotify.svg',
        amount: 2000,
        status: 'completed',
        createdAt: '2025-01-08T09:15:00Z',
        type: 'subscription',
        duration: '3 mois'
      },
      {
        id: 'txn_003',
        productName: 'Disney+',
        productImage: null,
        amount: 2500,
        status: 'pending',
        createdAt: '2025-01-14T16:45:00Z',
        type: 'subscription',
        duration: '1 mois'
      },
      {
        id: 'txn_004',
        productName: 'Amazon Prime Video',
        productImage: null,
        amount: 3000,
        status: 'completed',
        createdAt: '2025-01-05T11:20:00Z',
        type: 'subscription',
        duration: '1 mois'
      },
      {
        id: 'txn_005',
        productName: 'Canal+',
        productImage: null,
        amount: 15000,
        status: 'completed',
        createdAt: '2024-12-20T08:00:00Z',
        type: 'subscription',
        duration: '3 mois'
      }
    ];

    return {
      success,
      data: mockTransactions,
      total: mockTransactions.length
    };
  }

  serialize(data) {
    return null;
  }
}

export const transactionsSerializer = new TransactionsSerializer();
